<template>
  <span :class="tag_classes">
    <FontAwesomeIcon
      v-if="icon"
      :icon="icon"
    />
    <span
      v-if="$slots.default"
      :class="{ truncate: truncate }"
    >
      <slot />
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';
import { SIZE_CLASSES_TAG as SIZE_CLASSES } from '@/app/shared_components/tags/tag_constants';

const props = defineProps({
  color: {
    type: String,
    default: STATUS.DEFAULT,
    validator: (value) => Object.values(STATUS).includes(value),
  },
  icon: { type: [Array, String], default: null },
  size: {
    type: String,
    default: 'small',
    validator: (value) => Object.keys(SIZE_CLASSES).includes(value),
  },
  truncate: { type: Boolean, default: false },
});

const tag_classes = computed(() => {
  const theme = STATUS_COLORS[props.color];
  return [
    'inline-flex items-center gap-1 rounded-full font-medium',
    theme.TAG_BG,
    theme.TAG_TEXT,
    SIZE_CLASSES[props.size],
  ];
});
</script>
